import Component from '@averyano/core/src/classes/Component';

import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ParagraphAnimation from '../../animations/Paragraph';
GSAP.registerPlugin(ScrollTrigger);
import { split } from '../../utils/split';
import each from 'lodash/each';

export default class AboutSection extends Component {
	constructor() {
		super({
			element: '.about',
			elements: {
				info: '.about__info',
				btn: '.about__btn',
				imageOverlay: '.image-overlay',
				image: '.about__image',
				btnText: '.about__btn-text',
				btwArw: '.arw',
			},
		});
	}

	create() {
		super.createComponent();
		this.prepareInfoText();
		this.createTimeline();
	}

	createTimeline() {
		// if (window.isMobile) return;

		this.paragraphAnimation = new ParagraphAnimation({
			element: this.element,
		});

		this.paragraphAnimation.animateOut();

		// Build a paused timeline for the section reveal
		this.showTimeline = GSAP.timeline({
			paused: true,
			defaults: { ease: 'expo.out' },
		})
			.fromTo(
				this.elements.image,
				{ y: -200, autoAlpha: 0 },
				{ autoAlpha: 1, y: 0, duration: 2 },
				0 // start immediately
			)
			.to(
				this.elements.info,
				{ autoAlpha: 1, y: 0, duration: 1, delay: 0.62 },
				0.3 // matches previous delay: 0.3
			)
			.to(
				this.elements.imageOverlay,
				{ yPercent: 100, duration: 1.5 },
				0.3 // matches previous delay: 0.3
			)
			.to(
				this.elements.btwArw,
				{ autoAlpha: 1, duration: 1, delay: 0.62 },
				0.5 // matches previous delay: 0.5
			)
			.to(
				this.elements.btnText,
				{ autoAlpha: 1, duration: 1, delay: 0.62 },
				0.52 // matches previous delay: 0.5
			);

		ScrollTrigger.create({
			trigger: this.element,
			start: 'top 80%',
			end: 'bottom 20%',
			onEnter: () => this.show(),
			// onEnterBack: () => this.show(),
			// onLeave: () => this.hide(),
			onLeaveBack: () => this.hide(),
		});
	}

	prepareInfoText() {
		// const info = this.elements.info;
		// this.infoSpans = split({ element: info, expression: '' });
	}

	clearTimeline() {
		if (this.showTimeline) {
			this.showTimeline.kill();
			this.showTimeline = null;
		}
	}

	show() {
		// Play the composed timeline
		if (this.showTimeline) this.showTimeline.play(0);
		if (this.paragraphAnimation) this.paragraphAnimation.animateIn();
	}

	hide() {
		// Reverse the composed timeline
		if (this.showTimeline) this.showTimeline.reverse();
		if (this.paragraphAnimation) this.paragraphAnimation.animateOut();
	}

	destroy() {
		super.destroy();
		this.clearTimeline();
	}
}
